import React from "react";
import Head from "../../football/match/Head";
import RugbyInfo from "../../rugby/RugbyInfo";
import RugbyLineup from "../../rugby/RugbyLineup";
import RugbyTable from "../../rugby/RugbyTable";
import RugbyMatchHead from "../../rugby/RugbyMatchHead";

const RugbyMatchWidgetWrap = (props) => {
    const {
        dataId,
        dataType,
        head,
        data,
        headData,
        sport,
        difference,
        loadCSS,
        dataClient,
        websiteBaseUrl,
        dataPath,
        dataTitle,
        baseUrl,
        socketUrl,
        channel,
        event,
    } = props;

    const renderHeadWrap = (currentTab, children) =>
        head ? (
            <Head
                matchDetail={headData}
                difference={difference}
                sport={sport}
                dataClient={dataClient}
                id={dataId}
                currentTab={currentTab}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                title={dataTitle}
                socketUrl={socketUrl}
                channel={channel}
                event={event}
            >
                {children}
            </Head>
        ) : (
            children
        );

    switch (dataType) {
        // Self-contained, live rugby match-header widget (own header — not wrapped in <Head/>).
        case "rugby-match-detail":
            return (
                <RugbyMatchHead
                    serverData={data?.data}
                    dataId={dataId}
                    baseUrl={baseUrl}
                    sport={sport}
                    difference={difference}
                    loadCSS={loadCSS}
                    dataClient={dataClient}
                    socketUrl={socketUrl}
                    channel={channel}
                    event={event}
                />
            );
        case "rugby-match-info":
            return renderHeadWrap("info",
                <RugbyInfo
                    ServerData={data?.data}
                    loadCSS={loadCSS}
                    dataClient={dataClient}
                    difference={difference}
                    title={!head && dataTitle}
                    baseUrl={baseUrl}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}

                />
            );
        case "rugby-match-lineup":
            return renderHeadWrap("lineup",
                <RugbyLineup
                    ServerData={data}
                    loadCSS={loadCSS}
                    dataClient={dataClient}
                    difference={difference}
                    title={!head && dataTitle}
                    baseUrl={baseUrl}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                />
            );
        case "rugby-match-standings":
            return renderHeadWrap("standings",
                <RugbyTable
                    ServerData={data?.data}
                    loadCSS={loadCSS}
                    dataClient={dataClient}
                    difference={difference}
                    title={!head && dataTitle}
                    baseUrl={baseUrl}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}

                />
            );
        case "rugby-match":
            return (head && (<Head
                matchDetail={headData}
                difference={difference}
                sport={sport}
                dataClient={dataClient}
                id={dataId}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                title={dataTitle}

            />))

        default:
            return <h1>Rugby Match Widget Not Found!</h1>;
    }
};

export default RugbyMatchWidgetWrap;
